import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './Store';

// Define the initial state
interface CounterState {
    data: any;
    filterData: any;
}

const initialState: CounterState = {
    data: null,
    filterData: null,
};

// Create the slice
const counterSlice = createSlice({
    name: 'counter', // Slice name
    initialState, // Initial state
    reducers: {
        setData: (state, action) => {
            //  state.data = action.payload;
            // console.log("Data receive");
            state.data = action.payload;
            // console.log("Data set");
        },
        findData: (state, action: PayloadAction<any[]>) => {
            if (state.data) {
                // console.log("get data", action);
                state.filterData = state?.data.filter(item => action.payload?.includes(item.visitTimeId));
                // console.log("New Filtered Data", state.filterData);

            }
            
        },
    },
});

// Export the actions
export const { findData, setData } = counterSlice.actions;
export const selectCount = (state: RootState) => state.counter.data

// Export the reducer
export default counterSlice.reducer;